export default __webpack_public_path__ + "static/media/grafema_martini-contest_07.ec6e8837.jpg";